import { ContactPage, Breadcrumbs, CallToAction, SupportCountries } from "@/components/features/support";
import Footer from "../../components/common/layout/Footer";
import SEO from "@/components/common/seo/seo";

export default function Support() {
  return (
    <div>
      <SEO
            title="Support - SAN micron"
            description="Get help and support from SAN micron. Find answers to frequently asked questions, contact our support team, and access resources to assist you."
        />
      <Breadcrumbs />
      {/* <FAQ /> */}
      <ContactPage />
      <CallToAction />
      <SupportCountries />
      <Footer />
    </div>
  )
}